package com.downdogapp

typealias DoubleRange = ClosedFloatingPointRange<Double>

val DoubleRange.size get() = endInclusive - start

operator fun DoubleRange.plus(other: DoubleRange) =
  (start + other.start)..(endInclusive + other.endInclusive)

operator fun DoubleRange.times(factor: Double) =
  (start * factor)..(endInclusive * factor)

operator fun IntRange.plus(other: IntRange) =
  (first + other.first)..(last + other.last)

operator fun IntRange.times(factor: Int) = (start * factor)..(endInclusive * factor)

operator fun IntRange.times(factor: Double) = (start * factor)..(endInclusive * factor)

operator fun IntRange.div(factor: Int) = (start / factor)..(endInclusive / factor)

operator fun IntRange.div(factor: Double) = (start / factor)..(endInclusive / factor)

fun <T : Comparable<T>> ClosedRange<T>.intersect(other: ClosedRange<T>): ClosedRange<T>? {
  val start = maxOf(start, other.start)
  val endInclusive = minOf(endInclusive, other.endInclusive)
  return if (start > endInclusive)
    null
  else
    start..endInclusive
}

operator fun <T : Comparable<T>> ClosedRange<T>.component1() = start

operator fun <T : Comparable<T>> ClosedRange<T>.component2() = endInclusive

fun <T : Any> T?.notNull(errorMessage: String): T = checkNotNull(this) { errorMessage }
